import React from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../../layouts/app/AppLayout';
import './custom.scss';

import { translateThis } from '../../helpers/language.helper';
import AppIcons from '../../assets/images/icons';

import SVGIcons from '../../assets/images/icons/svgIcons';
import waterProjDoc from '../../assets/images/projects/water-project-2021-3.pdf';



const WaterProject = () => {
    // custom home functions here
    const pageName = "Projects";

    const onButtonClick = () => {
        const pdfUrl = `${waterProjDoc}`;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "water-project-2021-3.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper individual-project-wrapper f-wrp">
                <div className='individualProject-main-banner f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='banner-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                    <div className='banner-content-box f-wrp'>
                                        <div className='content-main-box f-wrp'>
                                            <h2>{translateThis("Water energy for peace")}</h2>
                                            <h1>{translateThis("Providing safe water and green energy for sustainable development")}</h1>
                                            <div className='btn-wrp'>
                                                <Link to={'/join-our-community'} className='sqr-btn'>{translateThis('Join our mission')}</Link>
                                                <Link to={'/projects/water-project-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12">
                                    <div className='banner-img-sec f-wrp'>
                                        <span className='banner-main-img'><img src={AppIcons.waterBanner} alt='about us' /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='whatWeDo-main-block f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='whatWeDo-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                                    <div className='whatWeDo-block-box f-wrp'>
                                        <h2>{translateThis("What we do")}</h2>
                                        <p>{translateThis("We provide safe drinking water and green energy to schools and hospitals, promoting sustainable development. Our off-the-grid generators produce pure water from ambient air vapor.")}</p>
                                        <div className='btn-wrp'>
                                            <Link to={'/projects/water-project-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <div className='content-sub-box f-wrp'>
                                        <div className='each-content-box moreThan f-wrp'>
                                            <h2>{translateThis("315,000")}</h2>
                                            <p>{translateThis("Children die every year from diarrheal diseases caused by unsafe water and poor sanitation in Africa.")}</p>
                                        </div>
                                        <div className='each-content-box upTo f-wrp'>
                                            <h2>{translateThis("40 billion")}</h2>
                                            <p>{translateThis("Hours are lost annually in Sub-Saharan Africa to water collection, equivalent to a year's labor by France's entire workforce.")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='aboutUs-main-block f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='aboutUs-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12">
                                    <div className='aboutUs-img-sec f-wrp'>
                                        <span className='aboutUs-main-img'><img src={AppIcons.waterAbt} alt='about us' /></span>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                    <div className='aboutUs-content-sec f-wrp'>
                                        <div className='aboutUs-intro-box f-wrp'>
                                            <h1>{translateThis("About")}<b>{translateThis("us")}</b></h1>
                                            <p>{translateThis("WDP, led by His Excellency Vishnou Toolcanon, focuses on improving living conditions through innovative projects. We aim for universal access to clean water and energy by 2030.")}</p>
                                            <div className='btn-wrp'>
                                                <Link to={'/projects/water-project-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                            </div>
                                        </div>
                                        <div className='story-intro-box f-wrp'>
                                            <h4><b>{translateThis("Projects and Initiatives")}</b></h4>
                                            <p>{translateThis("Discover our innovative solutions, including off-the-grid water generators and strategic partnerships, aimed at providing clean water and green energy to communities across Africa, driving sustainable development.")}</p>
                                            <div className='btn-wrp'>
                                                <Link onClick={onButtonClick} className='pln-btn'>{translateThis('Download full document')} <SVGIcons.LearnMoreArrow /></Link>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default WaterProject;